export default {
  vueMaterialDesignIcons: {
    Vuejs: require("@icon/Vuejs").default,
    LanguageHtml5: require("@icon/LanguageHtml5").default,
    FormatFont: require("@icon/FormatFont").default,
    TableRow: require("@icon/TableRow").default,
    Textbox: require("@icon/Textbox").default,
    CheckboxBlank: require("@icon/CheckboxBlank").default,
    ArrowExpandHorizontal: require("@icon/ArrowExpandHorizontal").default,
    PanHorizontal: require("@icon/PanHorizontal").default,
    Palette: require("@icon/Palette").default,
    CheckCircle: require("@icon/CheckCircle").default,
    ProgressClock: require("@icon/ProgressClock").default,
    AlphaSCircle: require("@icon/AlphaSCircle").default,
    CardText: require("@icon/CardText").default,
    Close: require("@icon/Close").default,
    Minus: require("@icon/Minus").default,
    Alert: require("@icon/Alert").default,
    ChevronRight: require("@icon/ChevronRight").default,
    ViewStream: require("@icon/ViewStream").default,
    ArrowDownDropCircle: require("@icon/ArrowDownDropCircle").default,
    ViewList: require("@icon/ViewList").default,
    CheckboxMarked: require("@icon/CheckboxMarked").default,
    File: require("@icon/File").default,
    EyeOff: require("@icon/EyeOff").default,
    Eye: require("@icon/Eye").default,
    Menu: require("@icon/Menu").default,
    Email: require("@icon/Email").default
  }
};
